export const layoutMessages = {
  logoAlt: 'Warm Fuzzy Story Club Logo',
  logout: 'Logout',
  adminSection: 'Admin',
  roleTemplates: 'Role Templates',
  styleTemplates: 'Style Templates',
  storyTemplates: 'Story Templates',
  generatedStories: 'Generated Stories',
  characters: 'Characters',
} as const;
